import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

const addUnauthorizedInterceptor = (client: AxiosInstance) => {
    client.interceptors.response.use(
        (response: AxiosResponse) => response,
        (error: AxiosError) => {
            if (error.response?.status === 401) {
                return new Event('auth:unauthorized');
            }
            return Promise.reject(error);
        }
    );
};

export { addUnauthorizedInterceptor };
